// Ref: https://medium.com/front-end-weekly/html5-form-validation-in-react-65712f778196
//      https://time2hack.com/form-with-react-html5-validations/
//      https://developer.mozilla.org/en-US/docs/Web/Guide/HTML/HTML5/Constraint_validation
import { Heading } from '@chakra-ui/react';
import React from 'react';

const FormHeading = (props) => {
  const { title, ...rest } = props;
  return (
    <Heading size="md" {...rest}>
      {title}
    </Heading>
  );
};
export default FormHeading;
